import { UserAPI } from './api/index.ts';

export const user = UserAPI.getInstance();
